import {Pipe, Sanitizer, SecurityContext} from '@angular/core';

@Pipe({name: 'safeHtml'})
export class SafeHtml {
  constructor(private sanitizer:Sanitizer){}

  transform(html) {
    return this.sanitizer.sanitize(SecurityContext.STYLE, html);
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/trust.ts